module.exports = __webpack_public_path__ + "img/20200104131254622.d52006a7.jpg";